import type { IAiUsageConfig } from '@ztechapps/common.contract'
import { AiBillingScopeEnum } from '@ztechapps/common.contract'

/**
 * Single source of truth for QuickScore's AI-usage billing config — bound identically by both
 * the api and worker containers so the two processes can never drift on billingScope/currency
 * defaults. QuickScore bills per-teacher (`User` scope — each teacher has their own balance
 * under the shared `DFT` tenant), unlike a shared-org consumer (e.g. TotalMilk's `Tenant`
 * scope). The billing-admin permission is the generic, app-agnostic `canManageAiBilling`
 * (enforced in the shared engine via `CanManageAiBillingValidator`), so it is not configured here.
 * `checkoutRedirectUrl` is the mobile app's deep link — `CreateCreditPurchase` derives the
 * gateway's `successUrl`/`cancelUrl` from it server-side, so a caller can never redirect a
 * checkout session to an arbitrary destination.
 */
export const quickscoreAiUsageConfig: IAiUsageConfig = {
  billingScope: AiBillingScopeEnum.User,
  defaultCurrency: 'PHP',
  checkoutRedirectUrl: 'quickscore://credit-purchase-return',
}
